/**
 * 教程相关API服务
 */

import { getAuthHeaders } from '../utils/auth';

import requestV2 from '@/utils/requestV2';


const API_URL = 'system/tutorials';

/**
 * 获取所有可用教程列表
 * @returns {Promise<Array>} 教程列表
 */
export const fetchTutorials = async () => {
  try {
    const response = await requestV2.get(`${API_URL}/list`);
    if (!response.data.code == 200) {
      throw new Error(`HTTP error! status: ${response.data.message}`);
    }
    return await response.data.data
  } catch (error) {
    console.error('获取教程列表失败:', error);
    throw error;
  }
};

/**
 * 获取单个教程详情
 * @param {number} id 教程ID
 * @returns {Promise<Object>} 教程详情
 */
export const fetchTutorialById = async (id) => {
  try {
    const response = await requestV2.get(`${API_URL}/${id}`);
    if (!response.data.code == 200) {
      throw new Error(`HTTP error! status: ${response.data.message}`);
    }
    return await response.data.data
  } catch (error) {
    console.error('获取教程详情失败:', error);
    throw error;
  }
};

/**
 * 管理员获取所有教程
 * @returns {Promise<Array>} 所有教程列表
 */
export const fetchAdminTutorials = async () => {
  try {
    const headers = getAuthHeaders();
    const response = await requestV2.get(`${API_URL}/list`);
    if (!response.data.code == 200) {
      throw new Error(`HTTP error! status: ${response.data.message}`);
    }
    return await response.data.data
  } catch (error) {
    console.error('获取管理员教程列表失败:', error);
    throw error;
  }
};

/**
 * 管理员获取单个教程详情
 * @param {number} id 教程ID
 * @returns {Promise<Object>} 教程详情
 */
export const fetchAdminTutorialById = async (id) => {
  try {
    const headers = getAuthHeaders();
    const response = await requestV2.get(`${API_URL}/admin/${id}`);
    if (!response.data.code == 200) {
      throw new Error(`HTTP error! status: ${response.data.message}`);
    }
    return await response.data.data
  } catch (error) {
    console.error('获取管理员教程详情失败:', error);
    throw error;
  }
};

/**
 * 上传教程封面图片
 * @param {File} file 图片文件
 * @returns {Promise<Object>} 上传结果
 */
export const uploadTutorialImage = async (file) => {
  try {
    const headers = getAuthHeaders();
    delete headers['Content-Type']; // 让浏览器自动设置multipart/form-data

    const formData = new FormData();
    formData.append('image', file);

    const response = await fetch(`${API_URL}/admin/upload-image`, {
      method: 'POST',
      headers,
      body: formData
    });

    if (!response.data.code == 200) {
      throw new Error(`HTTP error! status: ${response.data.message}`);
    }
    
    return await response.data.data
  } catch (error) {
    console.error('上传教程封面图片失败:', error);
    throw error;
  }
};

/**
 * 添加新教程
 * @param {Object} tutorialData 教程数据
 * @returns {Promise<Object>} 添加结果
 */
export const addTutorial = async (tutorialData) => {
  try {
    const headers = {
      ...getAuthHeaders(),
      'Content-Type': 'application/json'
    };
    
    const response = await requestV2.post(`${API_URL}/addTutorials`,tutorialData);
    
    if (!response.data.code == 200) {
      throw new Error(`HTTP error! status: ${response.data.message}`);
    }
    
    return await response.data.data
  } catch (error) {
    console.error('添加教程失败:', error);
    throw error;
  }
};

/**
 * 更新教程
 * @param {number} id 教程ID
 * @param {Object} tutorialData 教程数据
 * @returns {Promise<Object>} 更新结果
 */
export const updateTutorial = async (id, tutorialData) => {
  try {
    const headers = {
      ...getAuthHeaders(),
      'Content-Type': 'application/json'
    };
    
    const response = await fetch(`${API_URL}/updateTutorials/${id}`, tutorialData);
    
    if (!response.data.code == 200) {
      throw new Error(`HTTP error! status: ${response.data.message}`);
    }
    
    return await response.data.data
  } catch (error) {
    console.error('更新教程失败:', error);
    throw error;
  }
};

/**
 * 删除教程
 * @param {number} id 教程ID
 * @returns {Promise<Object>} 删除结果
 */
export const deleteTutorial = async (id) => {
  try {
    const headers = getAuthHeaders();
    
    const response = await fetch(`${API_URL}/delete/${id}`);
    
    if (!response.data.code == 200) {
      throw new Error(`HTTP error! status: ${response.data.message}`);
    }
    
    return await response.data.data
  } catch (error) {
    console.error('删除教程失败:', error);
    throw error;
  }
}; 